export const MODAL_HIDE_EVENT = "modal:hide";
